import React, { Component } from 'react';

export class Rsvp extends Component {
    render() {
        return(
            <div className="rsvp" id="rsvp">
                <div className="rsvpTitle AmaticSC">RSVP</div>
                <p>RSVP is now closed. Thank you to everyone for responding. We'll see you all on our wedding!</p>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Rsvp.js